import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../queries';
import { handleError } from '../../../../components/ui/err/handleError';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../types';
import { IGetAsCsTemplateListParams } from './types';

export function useGetAiAgentTemplates(params: IGetAsCsTemplateListParams) {
  return useQuery({
    ...queries.aiAgent.asCsTemplateList(params),
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
